import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getAllCategorys, getFillterCategorys } from '../../redux/actions/category';
import { useStateContext } from '../../context/ContextProvider';
import { MealCategoryCard } from '../utils';
import { motion } from 'framer-motion';
import { FiGrid } from 'react-icons/fi';

function CategoriesSection() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentLang, currentDir } = useStateContext();
  const IsArabic = currentLang === "ar";
  const { isLoading, AllCategorys } = useSelector((state) => state.Categorys);

  useEffect(() => {
    // عرض جميع الفئات بدون pagination
    dispatch(getAllCategorys(1, 100));
  }, [dispatch]);


  return (

    <section className="relative py-24 md:py-32 overflow-hidden bg-back-secondary dark:bg-back-darkprimery">
    
      {/* Background */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-color-1/10 blur-3xl rounded-full"></div>
    
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-color-3/10 blur-3xl rounded-full"></div>
    
      <div className="container relative z-10">
    
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
    
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-color-1/10 border border-color-1/20 mb-6">
    
            <FiGrid className="text-color-1" />
    
            <span className="font-kufi text-color-1">
              {t("food categories")}
            </span>
    
          </div>
    
          <h2 className="h1 text-tcolor-4 dark:text-tcolor-1 mb-6">
    
            {t("Explore Our Categories")}
    
          </h2>
    
          <p className="body-2 text-n-6 dark:text-tcolor-2 max-w-3xl mx-auto leading-loose">
    
            {t("Discover a variety of authentic Yemeni dishes, from traditional Mandi to delicious Madbi, prepared with love and expertise.")}
    
          </p>
    
        </motion.div>
    
        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8">
    
          {AllCategorys?.map((category, index) => (
    
            <MealCategoryCard
              key={category._id || index}
              category={category}
              index={index}
            />
    
          ))}
    
        </div>
    
      </div>
    
    </section>

    
  );
}

export default CategoriesSection;